import * as React from "react";
import { Crown, Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const rituals = [{
  title: "The Full Groom Spa",
  description: "Complete head-to-tail grooming including a premium bath, haircut, and nail filing.",
  icon: Crown
}, {
  title: "Bath & Brush Refresh",
  description: "Deep-cleaning bath and brush-out to keep coats fresh between professional grooms.",
  icon: Flame
}];
export default function TheCraftRituals() {
  return <section data-section-id="149427" id="our-professional-grooming-services" className="bg-background text-foreground relative py-20 px-6 md:py-32">
      

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center ![margin:0px_0px_40px_0px]">
          <h2 className="font-sans font-bold text-4xl md:text-5xl lg:text-6xl text-foreground mb-6 tracking-tight">
            Our Professional Grooming Services
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Luxury mobile grooming delivered to your door with premium, pet-first care.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 group items-stretch">
          {rituals.map((ritual, i) => {
          const Icon = ritual.icon;
          return <Card key={i} data-index={i} className="bg-card border-primary/20 shadow-xl transition-all duration-500 group-hover:opacity-60 hover:!opacity-100 hover:scale-[1.02] hover:border-primary hover:shadow-[0_30px_60px_rgba(0,114,206,0.15)] flex flex-col h-full min-h-0 rounded-[3rem] p-2">
                <CardHeader className="pb-4 pt-10 px-10">
                  <Icon strokeWidth={1.5} className="w-16 h-16 text-primary mb-8" aria-hidden="true" />
                  <CardTitle className="font-sans font-bold text-3xl text-foreground tracking-tight mb-4">
                    {ritual.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-10 flex-grow">
                  <CardDescription className="text-muted-foreground text-lg leading-relaxed font-sans">
                    {ritual.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="px-10 pb-6 pt-2 flex items-center justify-center gap-3 flex-wrap">
                  <Button asChild className="rounded-full bg-primary text-primary-foreground font-sans font-bold h-14 px-10 text-lg hover:scale-[1.03] transition-all duration-300 shadow-lg hover:shadow-primary/20">
                    <Link to="https://booking.moego.pet/ol/landing?name=BarkBathMobileGroomingLLC">
                      Book Online Now
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}